// extracted by mini-css-extract-plugin
export default {"container":"StackPage_container__3WFzP"};